/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InitiativeImageReference } from '../../models/initiative-image-reference';

export interface GetInitiativeImageReferences$Params {
  initiativeId: string;
}

export function getInitiativeImageReferences(http: HttpClient, rootUrl: string, params: GetInitiativeImageReferences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InitiativeImageReference>>> {
  const rb = new RequestBuilder(rootUrl, getInitiativeImageReferences.PATH, 'get');
  if (params) {
    rb.path('initiativeId', params.initiativeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InitiativeImageReference>>;
    })
  );
}

getInitiativeImageReferences.PATH = '/initiative/{initiativeId}/images';
